import { Grid2, useMediaQuery } from "@mui/material";

import Header from "../../Common/Header";
import SupportMobileView from "./SupportMobileView";
import SupportWebView from "./SupportWebView";
import HowItWorks from "./HowItWorks/HowItWorks";
import Escalation from "./Escalation/Escalation";


const Support = () => {
    const isSmallScreen = useMediaQuery('(max-width:600px)')
  return (
    <main>
        <Header />
        { isSmallScreen ? <SupportMobileView /> : <SupportWebView />}
        <HowItWorks />
        <Escalation />
     </main>
  )
}

export default Support
